import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Avatar, ListItemIcon, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { setUserPro } from "../../lib/slices/businessPro";
import { setUser } from "../../lib/slices/userSlice";
import { setUserRoutes } from "../../lib/slices/path";

const style = {
  menuButton: {
    padding: "4px 8px",
    fontSize: "0.875rem",
    color: appcolors.slateGrey,
  },
};

export default function ProfileMenu({ styleProps, hoverProps }) {
  const naviagte = useNavigate();
  const { user } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            {...bindTrigger(popupState)}
            variant="contained"
            disableRipple
            startIcon={
              <Avatar
                sx={{ height: 32, width: 32, border: "2px solid #ffffff" }}
                src={user?.logoImage}
              />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor={appcolors.white}
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            sx={{
              width: 160,
              height: 45,
            }}
          >
            <Typography variant="body2" noWrap>
              {user?.firstname}
            </Typography>
          </Button>
          <Menu
            disableScrollLock
            {...bindMenu(popupState)}
            PaperProps={{
              sx: {
                width: 160,
                maxHeight: "100% !important",
                top: "64px !important",
              },
            }}
          >
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              width={"100%"}
              p="5px"
            >
              <Avatar sx={{ height: 50, width: 50 }} src={user?.logoImage} />
              <Typography
                variant="h6"
                fontSize={"0.875rem"}
                fontWeight={"400"}
                color={"primary"}
                textAlign={"center"}
                whiteSpace={"break-spaces"}
              >
                {user?.businessName}
              </Typography>
            </Stack>
            <MenuItem
              onClick={() => {
                popupState.close();
                naviagte("/dashboard/settings");
              }}
              sx={style.menuButton}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img
                  src={allIcons.settingIcon}
                  alt={"setting-icon"}
                  width={20}
                />
              </ListItemIcon>
              Settings
            </MenuItem>
            <MenuItem
              onClick={() => {
                popupState.close();
                localStorage.removeItem("user-data");
                naviagte("/login");
                localStorage.removeItem("user-Pro");
                localStorage.removeItem("user-routes");
                dispatch(setUser(null));
                dispatch(setUserPro(null));
                dispatch(setUserRoutes(null));
              }}
              sx={{ ...style.menuButton, mt: 1 }}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img
                  src={allIcons.logoutIcon}
                  alt={"setting-icon"}
                  width={20}
                />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
